import $ from 'jquery'
import 'peity'

const progresses = window.progresses || []
const summaries = window.summaries || []

export function populateProgress() {
  if (progresses.length === 0) {
    return
  }

  summaries.forEach(function (summary) {
    let totalProgress = 0
    let doneProgress = 0
    const foundProgs = []
    progresses.forEach(function (prog) {
      if (prog.courseSlug == summary.courseSlug) {
        foundProgs.push(prog)
      }
    })
    if (foundProgs.length == 0) {
      return
    }
    summary.chapters.forEach((chapter) => {
      chapter.lectures.forEach(() => {
        totalProgress++
      })

      foundProgs.forEach((prog) => {
        chapter.lectures.forEach((lecture) => {
          if (prog.chapterSlug !== chapter.chapterSlug) {
            return
          }
          const lectureSlug = lecture.lectureSlug
          if (!prog.lectures || !(lectureSlug in prog.lectures)) {
            return
          }
          const lectureProg = prog.lectures[lectureSlug]
          if (lectureProg.video) {
            doneProgress++
          }
        })
      })
    })

    const courseSlug = summary.courseSlug
    const $containerTag = $('#elearning_progress_container_' + courseSlug)
    let fill = ['#5284da', '#dcdcdc']
    if ($containerTag.hasClass('tnt-module-progress')) {
      const $parentTag = $containerTag.parent()
      $parentTag.removeClass('d-none') // show progress and live classes row
      const parentId = $parentTag.attr('id').split('_')[4]
      $('#video_no_classes_' + parentId).addClass('d-none') // hide live classes dates
      fill = ['white', '#da1717']
    }

    let moduleNumber = courseSlug.split('-')[1]
    if (courseSlug.indexOf('13-operando-em-mesas-proprietarias') > -1) {
      moduleNumber = 'BÔNUS'
    }
    $('#elearning_access_button_' + courseSlug).html(
      'Continuar o <strong>Módulo ' + moduleNumber + '</strong>'
    )
    $(
      '#elearning_progress_' +
        courseSlug +
        ' .elearning-progress-progress-chart'
    ).html(doneProgress + '/' + totalProgress)
    $(
      '#elearning_progress_' +
        courseSlug +
        ' .elearning-progress-progress-ratio'
    ).html(((100 * doneProgress) / totalProgress).toFixed(0) + '%')

    const containerWidth = $('#elearning_progress_' + courseSlug).width()
    const radius = Math.floor(containerWidth / 4.5)
    $('#elearning_progress_' + courseSlug + ' .elearning-chart').peity(
      'donut',
      {
        fill: fill,
        innerRadius: 10,
        radius: radius
      }
    )
  })
}
